// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","buttons":"buttons-2wk-m","modal":"modal-2BvXL","button":"button-uj15L","active":"active-grrhN"};